import { Component, OnInit, ViewChild } from '@angular/core';
import { PropertiesService } from '../properties.service';
import { TemplatesService } from '../templates.service';
import { TemplateInterface } from 'models/template.model';
import Swal from 'sweetalert2'
import { countries, Country } from "countries-list";
import { getCode } from "country-list";
import timezones, { Timezone } from "timezones.json";
import { flatten } from '@angular/compiler';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';

declare var feather:any;

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss']
})
export class ConfigurationComponent implements OnInit {
  

  private timezones: Array<Timezone>;
  private allowedTimezones: Array<Timezone>;
  private blockedTimezones: Array<Timezone>;
  private countries: Array<Country>;
  private tierOneCountries: Array<Country>;
  private allowedCountries: Array<Country>;
  private blockedPostalCodes: Array<string>;
  private blockedCities: Array<string>;
  private blockedCountries: Array<Country>;
  private blockedUserAgents: Array<string>;

  private allowedUserAgents: Array<string>;
  private templatedUserAgents: Array<string>;
  private blockedBrowserHeaders: Array<string>;
  private templatedBrowserHeaders: Array<string>;
  public selectedTemplate: TemplateInterface;

  selectTemplate(template: TemplateInterface) {
    if (this.selectedTemplate && this.selectedTemplate.previewUrl === template.previewUrl) {
      this.selectedTemplate = null;
    } else {
      this.selectedTemplate = template;
    }
  }

  selectUserAgent = (userAgent: string) => {
    if (this.allowedUserAgents.includes(userAgent)) {
      //Remove
      const index = this.allowedUserAgents.indexOf(userAgent);
      if (index >= 0) {
        this.allowedUserAgents.splice(index, 1);
      }

      //Add
      this.blockedUserAgents.push(userAgent);
    } else if (this.blockedUserAgents.includes(userAgent)) {
      //Remove
      const index = this.blockedUserAgents.indexOf(userAgent);
      if (index >= 0) {
        this.blockedUserAgents.splice(index, 1);
      }

      //Add
      this.allowedUserAgents.push(userAgent);
    }

    this.properties.current.configuration.configuration.blockedUserAgents = this.blockedUserAgents;

    this.properties.updatePropertyConfiguration(this.properties.current).then(success => console.log('updated useragents'));
  };

  removeCity = (city: string) => {
    console.log('removing city 1');
    if (!this.properties.current.configuration.configuration.blockedCities) return;
    console.log('removing city 12', city, this.properties.current.configuration.configuration.blockedCities);
    //Find the code
    const cityIndex = this.properties.current.configuration.configuration.blockedCities.indexOf(city);
    
    if (cityIndex === null || cityIndex === -1) return;
    console.log('removing city 3');
    this.properties.current.configuration.configuration.blockedCities.splice(cityIndex, 1);
    this.blockedCities = this.properties.current.configuration.configuration.blockedCities;

    this.properties.updatePropertyConfiguration(this.properties.current).then(success => console.log('updated cities'));
  }

  addCity = (city: string) => {
    if (!this.properties.current.configuration.configuration.blockedCities) {
        this.properties.current.configuration.configuration.blockedCities = [city];  
    } else {
      this.properties.current.configuration.configuration.blockedCities.push(city);
    }
    this.blockedCities = this.properties.current.configuration.configuration.blockedCities;
    this.properties.updatePropertyConfiguration(this.properties.current).then(success => console.log('updated cities'));
  }

  removePostalCode = (postalCode: string) => {
    if (!this.properties.current.configuration.configuration.blockedPostalCodes) return;
    
    //Find the code
    const postalCodeIndex = this.properties.current.configuration.configuration.blockedPostalCodes.indexOf(postalCode);
    if (!postalCodeIndex || postalCodeIndex === -1) return;

    this.properties.current.configuration.configuration.blockedPostalCodes.splice(postalCodeIndex, 1);

    this.properties.updatePropertyConfiguration(this.properties.current).then(success => console.log('updated postal codes'));
  }

  addPostalCode = (postalCode: string) => {
    if (!this.properties.current.configuration.configuration.blockedPostalCodes) {
        this.properties.current.configuration.configuration.blockedPostalCodes = [postalCode];  
    } else {
      this.properties.current.configuration.configuration.blockedPostalCodes.push(postalCode);
    }
    this.blockedPostalCodes = this.properties.current.configuration.configuration.blockedPostalCodes;
    this.properties.updatePropertyConfiguration(this.properties.current).then(success => console.log('updated postal codes'));
  }

  loadBlockedUserAgents = () => {
    if (!this.properties.current.configuration.configuration.blockedUserAgents) return;

    //Get blocked list
    this.properties.current.configuration.configuration.blockedUserAgents.forEach((userAgent: string) => {
      //Remove
      const index = this.templatedUserAgents.indexOf(userAgent);
      if (index >= 0) {
        this.templatedUserAgents.splice(index, 1);
      }

      this.blockedUserAgents.push(userAgent);
    });
  }

  loadCurrentBlockedTimezones = () => {
    if (!this.properties.current.configuration.configuration.blockedTimezones) return;

    //Get blocked list
    this.properties.current.configuration.configuration.blockedTimezones.forEach((timezone: string) => {


      //Find the timezone based on the utc codes
      const removeTimezoneIndex: number = this.allowedTimezones.findIndex((tz: Timezone) => {
        return tz.utc.includes(timezone);
      });

      const removedTimezone: Timezone = this.allowedTimezones.find((tz: Timezone) => {
        return tz.utc.includes(timezone);
      });

      if (removeTimezoneIndex && removeTimezoneIndex >= 0) {
        this.allowedTimezones.splice(removeTimezoneIndex, 1);
        this.blockedTimezones.push(removedTimezone);
      }
    });
  }

  loadCurrentBlockedCities = () => {
    if (!this.properties.current.configuration.configuration.blockedCities) return;

    //Get blocked list
    this.properties.current.configuration.configuration.blockedCities.forEach((city: string) => {
      this.blockedCities.push(city);
    });
  }

  loadCurrentBlockedPostalCodes = () => {
    if (!this.properties.current.configuration.configuration.blockedPostalCodes) return;

    //Get blocked list
    this.properties.current.configuration.configuration.blockedPostalCodes.forEach((postal: string) => {
      this.blockedPostalCodes.push(postal);
    });
  }

  loadCurrentBlockedCountries = () => {
    if (!this.properties.current.configuration.configuration.blockedCountries) return;

    //Get blocked list
    this.properties.current.configuration.configuration.blockedCountries.forEach((countryCode: string) => {
      const country = countries[countryCode];

      //Remove
      const index = this.allowedCountries.indexOf(country);
      if (index >= 0) {
        this.allowedCountries.splice(index, 1);
      }

      this.blockedCountries.push(country);
    });
  }

  selectTimezone = (timezone: Timezone) => {
    if (this.allowedTimezones.includes(timezone)) {
      //Remove
      const index = this.allowedTimezones.indexOf(timezone);
      if (index >= 0) {
        this.allowedTimezones.splice(index, 1);
      }

      //Add
      this.blockedTimezones.push(timezone);
    } else if (this.blockedTimezones.includes(timezone)) {
      //Remove
      const index = this.blockedTimezones.indexOf(timezone);
      if (index >= 0) {
        this.blockedTimezones.splice(index, 1);
      }

      //Add
      this.allowedTimezones.push(timezone);
    }

    this.properties.current.configuration.configuration.blockedTimezones = flatten(this.blockedTimezones.map(tz => tz.utc));

    console.log(`Updating with `, this.properties.current.configuration.configuration.blockedTimezones);
    this.properties.updatePropertyConfiguration(this.properties.current).then(success => console.log('updated timezones'));
  }

  selectCountry = (country: Country) => {
    if (this.allowedCountries.includes(country)) {
      //Remove
      const index = this.allowedCountries.indexOf(country);
      if (index >= 0) {
        this.allowedCountries.splice(index, 1);
      }

      //Add
      this.blockedCountries.push(country);
    } else if (this.blockedCountries.includes(country)) {
      //Remove
      const index = this.blockedCountries.indexOf(country);
      if (index >= 0) {
        this.blockedCountries.splice(index, 1);
      }

      //Add
      this.allowedCountries.push(country);
    }

    this.properties.current.configuration.configuration.blockedCountries = this.blockedCountries.map(country => getCode(country.name));

    this.properties.updatePropertyConfiguration(this.properties.current).then(success => console.log('updated countries'));
  }

  constructor(private properties: PropertiesService, private templateService: TemplatesService) {
    this.countries = [];
    this.tierOneCountries = [];
    this.allowedUserAgents = [];
    this.allowedTimezones = [];
    this.blockedTimezones = [];
    this.allowedCountries = [];
    this.blockedCountries = [];
    this.blockedUserAgents = [];
    this.blockedPostalCodes = [];
    this.blockedCities = [];
    this.blockedBrowserHeaders = [];
    this.templatedBrowserHeaders = [];
    this.timezones = [];

    //TODO load dynamically from RTFB
    this.templatedUserAgents = [
      "facebookexternalhit/1.1 (+http://www.facebook.com/externalhit_uatext.php)",
      "Mozilla/5.0 zgrab/0.x",
      "Slackbot-LinkExpanding 1.0 (+https://api.slack.com/robots)",
      "Slackbot 1.0 (+https://api.slack.com/robots)"
    ];

    this.allowedUserAgents = this.templatedUserAgents;
  }

  confirmUseTemplate(template: TemplateInterface) {
    Swal.fire({
      title: 'Are you sure?',
      text: "This will delete any changes you have made to your current template!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, reset it!'
    }).then((result) => {
      if (result.value) {
        Swal.fire(
          'New Template!',
          `You have successfully set a new template up!`,
          'success'
        );
        this.useTemplate(template);
      }
    });
  }

  async useTemplate(template: TemplateInterface) {
    console.log(template);
    this.properties.current.template = template;
  }


  private tierOneCountriesList = ["Norway", "Switzerland", "United States", "Germany", "Australia", "Luxembourg", "Ireland", "Iceland", "Sweden", "Canada", "Netherlands", "United Kingdom", "Singapore", "Japan", "Hong Kong", "Denmark", "France", "China"];

  ngOnInit() {
    for (const timezone in timezones) {
      if (Object.prototype.hasOwnProperty.call(timezones, timezone)) {
        const tz = timezones[timezone];
        this.allowedTimezones.push(tz);
      }
    }

    for (const country in countries) {
      if (Object.prototype.hasOwnProperty.call(countries, country)) {
        const countryElement: Country = countries[country];
        this.allowedCountries.push(countryElement);

        if (this.tierOneCountriesList.includes(countryElement.name)) {
          this.tierOneCountries.push(countryElement);
        }
      }
    }



    //Check Blocked Countries
    this.loadCurrentBlockedCountries();
    this.loadCurrentBlockedTimezones();
    this.loadBlockedUserAgents();
    this.loadCurrentBlockedPostalCodes();
    this.loadCurrentBlockedCities();

    setTimeout(() => {
      feather.replace();
    }, 100);
  }

}
